import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";
import { APP_WARNING } from "../_constants/actionConstants";

export default function raiseWarning(type = APP_WARNING.WARNING, message = "") {
  const warningId = getUUID();

  if (!message)
    message = "Request could not be processed. Please contact the system administrator.";

  const newWarning = { warningId, type, message };
  actionScripts.ADD_WARNING.run(newWarning);
  console.warn(type, message);
}
